var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5828 11.2242L23.5972 10.2298C24.1095 9.71755 24.1296 9.16513 23.6776 8.7031L23.3361 8.3616C22.8841 7.90961 22.3317 7.95983 21.8194 8.45199L20.805 9.4564L22.5828 11.2242ZM10.7408 23.0359L8.42062 23.9299C8.17956 24.0303 7.92846 23.7491 8.01886 23.508L8.97305 21.2782L19.9412 10.3201L21.6989 12.0879L10.7408 23.0359Z",
    fill: "#414141"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/Pencil.6cb49a6a9108ebf0efe9e52c720ef476.svg";
export { ForwardRef as ReactComponent };